import { formatCurrency } from './helpers';

declare const Chart: any;

const MONTHS_TR = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];

export function renderRevenueChart(canvasId: string, data: Array<{ month: string; total: number }>) {
  const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
  if (!canvas || typeof Chart === 'undefined') return;
  const ctx = canvas.getContext('2d')!;
  const sorted = [...data].reverse();
  const labels = sorted.map(d => { const [y, m] = d.month.split('-'); return MONTHS_TR[parseInt(m) - 1] + ' ' + y.slice(2); });
  const values = sorted.map(d => d.total);
  // Dekoratif gradient yerine düz, düşük alfa dolgu.
  const gradient = 'rgba(21, 124, 128, 0.10)';
  new Chart(ctx, {
    type: 'line',
    data: {
      labels,
      datasets: [{
        label: 'Tahsilat', data: values, borderColor: '#157c80', backgroundColor: gradient, fill: true, tension: 0.35,
        pointBackgroundColor: '#157c80', pointBorderColor: '#157c80', pointRadius: 4, pointHoverRadius: 6, borderWidth: 2,
      }]
    },
    options: {
      responsive: true, maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        tooltip: { backgroundColor: '#FFFFFF', titleColor: '#1A1A1A', bodyColor: '#6B6B6B', borderColor: '#E8E7E3', borderWidth: 1, padding: 12,
          callbacks: { label: (c: any) => formatCurrency(c.parsed.y) } }
      },
      scales: {
        x: { grid: { color: 'rgba(0,0,0,0.06)' }, ticks: { color: '#9B9B9B', font: { size: 11 } } },
        y: { grid: { color: 'rgba(0,0,0,0.06)' }, ticks: { color: '#9B9B9B', font: { size: 11 }, callback: (v: number) => '₺' + (v >= 1000 ? (v / 1000).toFixed(0) + 'b' : v) } }
      }
    }
  });
}
